import {
  CURRENT_QUEUE_NEW_STATUS,
  LOAD_QUEUES_SUCCESS,
  SET_QUEUE_PAGE_YEAR,
} from 'modules/queues/action-types'
import {
  getQueuesPagination,
  getQueuesActivePage,
  getQueuesMonths,
  getQueuesYears,
} from 'modules/queues/selectors';
import { setQueuePage } from 'modules/queues/actions';


export default ({ dispatch, getState }) => next => action => {
  const result = next(action);
  const setQueuesActivePage = () => {
    const state = getState();
    const activePage = getQueuesActivePage(state);
    const years = getQueuesYears(state);
    const months = getQueuesMonths(state);
    const isActivePage = activePage && activePage.year && activePage.month;

    if (!isActivePage && years.length) {
      const currentPage = {
        year: activePage.year || years[years.length - 1],
        month: months[months.length - 1],
      };

      dispatch(setQueuePage('both', currentPage));
    }
  }

  const setQueuesYearPage = () => {
    const state = getState();
    const pagination = getQueuesPagination(state);
    const months = pagination[action.payload.year]

    dispatch(setQueuePage('month', months[months.length - 1]))
  }


  if (action && typeof action.type === 'string') {
    if ([CURRENT_QUEUE_NEW_STATUS, LOAD_QUEUES_SUCCESS].indexOf(action.type) !== -1) {
      setQueuesActivePage()
    }
    else if (action.type === SET_QUEUE_PAGE_YEAR) {
      setQueuesYearPage()
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/queuesPagination.js